module.exports = __webpack_public_path__ + "static/media/Warning-Filled-red.4fd5f574.svg";